import distance from 'images/year-in-review/2017/backgrounds/personal-distance.jpg'
import duration from 'images/year-in-review/2017/backgrounds/personal-duration.jpg'
import challenges from 'images/year-in-review/2017/backgrounds/personal-sponsored-challenges.jpg'

const backgrounds = {
  distance,
  duration,
  challenges,
}
export default backgrounds



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Personal/personalBackgrounds.js